import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Layout.css';
import bannerImage from '../assets/banner.jpg';

const Layout = ({ children }) => {
  const bannerStyle = {
    backgroundImage: `linear-gradient(rgba(128, 128, 128, 0.4), rgba(128, 128, 128, 0.4)), url(${bannerImage})`
  };

  return (
    <div className="layout">
      {/* Title Banner */}
      <div className="title-banner" style={bannerStyle}>
        <Container>
          <h1>Birmingham Go Club</h1>
          <p>Connecting Go players in Birmingham, Alabama</p>
        </Container>
      </div>

      {/* Navigation Bar */}
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/">Birmingham Go</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/about">About</Nav.Link>
              <Nav.Link as={Link} to="/howtoplay">How to Play</Nav.Link>
              <Nav.Link as={Link} to="/events">Events</Nav.Link>
              <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content */}
      <main className="main-content">
        <Container>
          {children}
        </Container>
      </main>

      {/* Footer */}
      <footer className="footer">
        <Container>
          <p>&copy; {new Date().getFullYear()} Birmingham Go Club. All rights reserved.</p>
        </Container>
      </footer>
    </div>
  );
};

export default Layout; 